module.exports = __webpack_public_path__ + "img/25f477b0b0d0fe13c31cb01a3a816fa9.e9232a0a.jpg";